import StateObserver, { user } from 'src/StateObserver';
import { getPet } from 'src/game/pet';
import sounds from 'src/lib/sounds';
import { LockableFooterButton } from './LockableFooterButton';
import { isMatch2Available } from 'src/replicant/match2/match2.getters';
import { playMatch2 } from 'src/game/minigame/match2-timestep/match2.play';
import { playRescueLevel } from 'src/game/rescueLevel/rescueLevel.sequence';
import { rescueLevelGetActive } from 'src/replicant/rescueLevel/rescueLevel.getters';

export class MinigameButton extends LockableFooterButton {
  constructor() {
    super({
      type: 'game',
      isLocked: !isMatch2Available(StateObserver.getState().user),
    });
  }

  public async handleClick() {
    // Menu actions is locked
    if (StateObserver.getState().ui.lockMenu) return;
    if (getPet().conversation.inProgress()) return;

    this.setActive(true);
    sounds.sfx.play('ok');

    if (rescueLevelGetActive(user())) {
      await playRescueLevel({ origin: 'hud' });
      return;
    }

    await playMatch2({
      onStart: () => this.setActive(false),
      origin: 'hud',
    });
  }
}
